import React from "react";

export default function JournalSubscribers() {
  // Local dev: journal runs on 3002
  // Later in prod you can swap this to your deployed journal domain.
  const JOURNAL_ADMIN_URL =
    process.env.REACT_APP_JOURNAL_ADMIN_URL || "http://localhost:3002/admin/subscribers";

  return (
    <div className="w-full h-[calc(100vh-140px)]">
      <iframe
        title="Journal Subscribers"
        src={JOURNAL_ADMIN_URL}
        className="w-full h-full rounded-xl border border-[#105132]/20 bg-white"
      />
    </div>
  );
}